import { createContext, useEffect, useRef, useState } from "react";
import { useCookies } from "react-cookie";
import { useDispatch, useSelector } from "react-redux";
import { AuthAPI } from "../../api/AuthAPI";
import { UserAPI } from "../../api/UserAPI";
import { getToken } from "../../cookie/authCookie";
import { resetUser, setClubId, userInfo } from "../../redux/reducer/userReducer";
import { Cookies } from 'react-cookie';
import { rootAction } from "../../redux/reducer/rootReducer";
import { stompClientService } from "../../util/stompClientService";

const AuthContext = createContext();

function AuthProvider({ children }) {
  
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState({ type: '', content: '' });
  const [cookies, setCookie] = useCookies(["access_token", "refresh_token"]);
  const dispatch = useDispatch();
  const userInStore = useSelector((store) => store.user)
  const clubId = userInStore?.clubId;
  const getCurrentUser = async () => {
    try {
      setIsLoading(true);
      const user = await UserAPI.getCurrentUser();
  
      
      const userInfoDetails = {
        userId: user?.userId,
        userName: user?.userName,
      }

      //setCookie("user_info", { userInfoDetails });

      /// Dispatch User Info
      dispatch(userInfo(user))
      if (!clubId) {
        dispatch(setClubId(user?.clubs[0].clubId));
      }
      setIsLoading(false);
      setUser(user);
    } catch (err) {
      const cookie = new Cookies();
      setIsLoading(false);
      if (err.status == 401) {

        console.error('error', err)

        cookie.remove('access_token');
        cookie.remove('refresh_token');
       // cookie.remove('user_info');
        dispatch({ type: 'RESET_TO_INITIAL' });
        setUser(null);
      }
    }
  };

  useEffect(() => {
    getCurrentUser();
  }, []);

  const signIn = async (username, password) => {
    const user = {
      userName: username,
      userPassword: password
    }
    try {
      setIsLoading(true);
      setMessage({ type: '', content: '' });
      const result = await AuthAPI.signIn(user);
      setCookie("access_token", result.Data.accessToken, { expires: new Date(Date.now() + 1 * 3600000) });
      setCookie("refresh_token", result.Data.refreshToken);
      dispatch(rootAction.setSlideBarLink(''));
      await getCurrentUser();
      setIsLoading(false);
    } catch (error) {
        console.error(error);
        setMessage({ type: 'error', content: error?.response?.data?.Message })
        setIsLoading(false);
    }

  };
  const memberSignIn = async (loginDetails) => {
    try {
      setIsLoading(true);
      setMessage({ type: '', content: '' });
      const result = await AuthAPI.memberSignIn(loginDetails);
      setCookie("access_token", result.Data, { expires: new Date(Date.now() + 1 * 3600000) });
      dispatch(rootAction.setSlideBarLink(''));
      await getCurrentUser();
      setIsLoading(false);
      return result;
    } catch (error) {
      setMessage({ type: 'error', content: error?.response?.data?.Message });
      setIsLoading(false);
      return error
    }

  };
  const signOut = async (userName) => {
    try {
      setIsLoading(true);
      const signOutData = {
        username: userName,
        accessToken: getToken()
      }

      await AuthAPI.signOut(signOutData).then(() => {
        const cookie = new Cookies();
        setIsLoading(false);
        dispatch({ type: 'RESET_TO_INITIAL' });
        dispatch(rootAction.setIsTimerActive(false));
        setIsLoading(false);
        cookie.remove('access_token')
        cookie.remove('refresh_token')
        //cookie.remove('user_info')
        setUser(null);
        stompClientService.disconnect();
      })
    } catch (err) {
      setIsLoading(false);
      console.error('in signout error')
      dispatch({ type: 'RESET_TO_INITIAL' });
      const cookie = new Cookies();
      setIsLoading(false);
      console.error('errorin getCurrentUser', err)
      setUser(null);
      cookie.remove('access_token')
      cookie.remove('refresh_token')
      

    }
  };

  const authValue = {
    user,
    isLoading,
    setIsLoading,
    signIn,
    memberSignIn,
    signOut,
    message,
    setMessage,
    getCurrentUser
  };

  return (
    <AuthContext.Provider value={authValue}>{children}</AuthContext.Provider>
  );
}

export { AuthProvider, AuthContext };